import React, { useEffect  } from "react";
import { useDispatch, useSelector } from "react-redux";
import SliderImages from '~/components/layout/SliderImages';
import {
  Container,
  Logo,
  LogoMobile,
  LogoMobileFooter,
  Header,
  HeaderMobile,
  FormContainer,
  LoginBox,
  LeftContainer,
  FirstAccessContainer,
  SignInButton,
  RightContainer,
  Background,
  GradienteCenter,
  ImageCenterContainer,
  GradienteMobileImage
} from "./styles";

import arrowLeft from "~/assets/images/ic_arrow-left.svg";
import LogoMap from '~/assets/images/Login/meu-app-branca.png';
import LogoWhite from '~/assets/images/Login/logo-branca.png';
import Document from "../../../components/pages/ForgotPassword/Steps/Document";

import { useHistory } from 'react-router-dom';
import { CodeSentScreenForgotPassword } from "../../../components/pages/ForgotPassword/CodeSentScreenForgotPassword"; 
import { NewPassword } from '../../Auth/NewPassword';
import { ErrorNotification } from '../ErrorNotification';
import { AuthCodePreference } from '../AuthCodePreference';
import { InvalidEmail } from '../InvalidEmail';


const STEPS = {
  DOCUMENT: 10,
  AUTH_CODE_PREFERENCE: 20,
  CODE_SENT: 30,
  NEW_PASSWORD: 40,
  SUCCESS: 50,
  ERROR: 60,
  ERROR_EMAIL: 70,
  ERROR_EMAIL_EXISTING: 80,
};

function Forgot() {
  const dispatch = useDispatch();
  const stepReducer = useSelector((state) => state.stepsReducer.step);

  useEffect(() => {
    if (window.location.pathname === "/criar-senha") {
      dispatch({ type: "SET_STEP", step: 40 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();

  const renderFormContent = () => {
    switch (stepReducer) {
      case STEPS.DOCUMENT:
        return (
          <>
            <Document />
            <FirstAccessContainer className="mt-3 w-100">
              <SignInButton
                outline
                onClick={() => {
                  dispatch({ type: "SET_STEP", step: 0 });
                  history.push('/acessar')
                }}
              >
                <img src={arrowLeft} alt="Ícone de login" />
                <span>Voltar</span>
              </SignInButton>
            </FirstAccessContainer>
          </>
        );
      case STEPS.AUTH_CODE_PREFERENCE:
        return <AuthCodePreference isMFA={false} />;
      case STEPS.CODE_SENT:
        return <CodeSentScreenForgotPassword />;
      case STEPS.NEW_PASSWORD:
        return <NewPassword />;
      case STEPS.ERROR:
        return <ErrorNotification isMFA={false} />;
      case STEPS.ERROR_EMAIL:
        return <InvalidEmail isMFA={false} />;
      default:
        dispatch({ type: "SET_STEP", step: 10 });
        return  
    }
  };

  return (
    <Background>
      <GradienteCenter />
      <GradienteMobileImage />
      <Container>
        <LeftContainer>
          <img src={LogoWhite} alt="UltraGaz" />
        </LeftContainer>
        <ImageCenterContainer>
          <SliderImages />
        </ImageCenterContainer>
        <RightContainer>
          <LoginBox>
            <Header className="pt-4 pb-4">
              <Logo src={LogoMap} alt="UltraGaz" />
            </Header>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobile src={LogoWhite} alt="UltraGaz" />
            </HeaderMobile>
            <FormContainer>
              {renderFormContent()}
            </FormContainer>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobileFooter src={LogoMap} alt="UltraGaz" />
            </HeaderMobile>
          </LoginBox>
        </RightContainer>
      </Container>
    </Background>
  );
}

export default Forgot;
